export default __webpack_public_path__ + "static/media/guru.3b83d16b.png";